<template>
  <div class="fondo_transparente">
    <div class="ventana_modal" id="dragg-cont" ref="draggCont">
      <XCerrarModal @click="cerrarModal" id="XCerrar"/>
      <div class="headerAutores" id="dragg-header" @mousedown="dragMouseDown">
        <p>Autores</p>
      </div>
      <div class="bodyAutor">
        <div id="L1">
          <p id="autorDeco">{{autorSeleccionado.nombre}} {{autorSeleccionado.apellidos}}</p>
          <p id="enviar" @click="enviarAutor(autorSeleccionado)">&rtrif;</p>
        </div>
        <input class= "autores" type="search" v-model="busqueda" placeholder=" Buscar autor" autofocus />
        <div class= "lista">
          <ul
            @click="seleccionarAutor(autor)"
            v-for="autor in filtroAutores" :key="autor._id" :value="autor">
            {{autor.apellidos}}, {{autor.nombre}}
          </ul>
        </div>
        <!-- :class="{seleccionado: seleccionado === autor._id}" -->
        <br>
        <div id="L3">
          <button @click="nuevoAutor" class="button-med">
          <span class="icon-icoMasSolo ico"></span>Nuevo</button>
          <button @click="editAutor" class="button-med">
          <span class="icon-icoEditSolo ico"></span>Editar</button>
          <button @click="verifAutor" class="button-med">
          <span class="icon-icoSubirNube ico"></span>Guardar</button>
        </div>
        <br>
        <div v-show="visible" class="inputAutor">
          <input
            type="text"
            placeholder=" Nombre"
            id="nombre"
            class= "autores"
            v-model="autorGestionado.nombre">
          <input
            type="text"
            placeholder=" Apellidos"
            id="apellidos"
            class= "autores"
            v-model="autorGestionado.apellidos">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import XCerrarModal from './XCerrarModal.vue'
import axios from 'axios'
export default {
  props: {
    autores: Array
  },
  components: { XCerrarModal },
  name: 'ModalAutores',
  created () {
    this.URLbase = process.env.VUE_APP_ROOT_API
    this.busqueda = ''
  },
  data () {
    return {
      autorSeleccionado: {},
      autorGestionado: {},
      busqueda: '',
      visible: false,
      seleccionado: '',
      URLbase: '',
      positions: {
        clientX: undefined,
        clientY: undefined,
        movementX: 0,
        movementY: 0
      }
    }
  },
  methods: {
    seleccionarAutor (aut) {
      this.autorSeleccionado = aut
    },
    cerrarModal: function () {
      this.visible = false
      this.$emit('cerrar')
    },
    enviarAutor (seleccionado) {
      // console.log('Nombre: ' + seleccionado.nombre)
      if (seleccionado.nombre) {
      // console.log('Seleccionado es: ' + !!seleccionado.nombre)
        this.$emit('AddAutor', seleccionado)
        this.autorSeleccionado = {}
        this.busqueda = ''
      } else {
        console.log('Seleccionado es: ' + !!seleccionado.nombre)
      }
    },
    nuevoAutor () {
      this.visible = true
      this.autorGestionado = {}
      // this.autorGestionado.Id = '0'
    },
    editAutor () {
      this.visible = true
      this.autorGestionado = this.autorSeleccionado
    },
    verifAutor () {
      const a = this.autores.filter(e => e.nombre.toLowerCase() === this.autorGestionado.nombre.toLowerCase()).length
      const b = this.autores.filter(e => e.apellidos.toLowerCase() === this.autorGestionado.apellidos.toLowerCase()).length
      console.log(a)
      console.log(b)
      // console.log('Nombre repetido: ' + a)
      // console.log('Apellidos repetidos: ' + b)
      if (!!a && !!b) {
        this.autorGestionado = {}
        console.log('Nombre repetido')
        this.alertJoa('El autor ya está registrado', 'W')
      } else {
        console.log('Se puede guardar el autor')
        this.saveAutor()
      }
    },
    async saveAutor () {
      try {
        const url = `${this.URLbase}/autores/save`
        const autor = this.autorGestionado
        axios.post(url, autor)
          .then(result => {
            switch (result.data) {
              case 'error':
                this.alertJoa('Error en la actualización, reinicia la aplicación e intenta otra vez', 'E')
                break
              case 'success':
                console.log('Datos actualizados con éxito!')
                this.visible = false
                this.autorSeleccionado = this.autorGestionado
                break
            }
          })
          .catch(error => console.log(error))
        this.$emit('recargar')
      } catch (error) {
        alert(error)
      }
    },
    dragMouseDown: function (event) {
      event.preventDefault()
      // get the mouse cursor position at startup:
      this.positions.clientX = event.clientX
      this.positions.clientY = event.clientY
      document.onmousemove = this.elementDrag
      document.onmouseup = this.closeDragElement
    },
    elementDrag: function (event) {
      event.preventDefault()
      this.positions.movementX = this.positions.clientX - event.clientX
      this.positions.movementY = this.positions.clientY - event.clientY
      this.positions.clientX = event.clientX
      this.positions.clientY = event.clientY
      // set the element's new position:
      this.$refs.draggCont.style.top = (this.$refs.draggCont.offsetTop - this.positions.movementY) + 'px'
      this.$refs.draggCont.style.left = (this.$refs.draggCont.offsetLeft - this.positions.movementX) + 'px'
    },
    closeDragElement () {
      document.onmouseup = null
      document.onmousemove = null
    }
  },
  computed: {
    filtroAutores () {
      return this.autores.filter(autor => {
        return autor.nombre.toLowerCase().includes(this.busqueda.toLowerCase()) || autor.apellidos.toLowerCase().includes(this.busqueda.toLowerCase())
      })
    }
  }
}
</script>

<style scoped>
*{
  margin: 0;
  padding: 0;
}
.lista ul:hover{
  /* background-color: rgba(0, 58, 68, 0.9); */
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight:bold;
}
.ventana_modal{
    /* background: -webkit-linear-gradient(115deg, rgb(180, 180, 180),rgb(214, 214, 214),rgb(180, 180, 180), rgb(68, 68, 68)); */
    background-color: rgb(211, 210, 210);
    width: 400px;
    /* min-height: 200px; */
    top: 60%;
    left: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
    border-radius: 5px;
    display: grid;
    grid-template-rows: 20% 80%;
    font-family: OpenL;
    /* border:  1px solid rgb(179, 179, 179) */
    z-index: 100;
    box-shadow: rgb(43, 43, 43) 4px 4px 20px;
}
.headerAutores{
  background-color: var(--azul2);
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  width: 100%;
  display: flex;
}
#dragg-cont {
  position: absolute;
  z-index: 9;
}
#dragg-header {
  cursor: move;
  z-index: 10;
}
#XCerrar{
  z-index: 11;
}
.headerAutores p{
  text-align: left;
  margin-left: 20px;
  align-self: center;
  color: var(--na);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 30px;
  font-weight: lighter;
}
.bodyAutor{
  margin: 18px;
  display:flex;
  flex-direction: column;
  color:rgb(20, 76, 109)
}
#L1{
  height: 25px;
  display: inline-flex;
  justify-content: space-between;
  margin-bottom: 5px;
  /* border: 0.5px solid orange; */
}
#L1 #autorDeco{
  text-align: left;
  /* padding-bottom: 5px; */
  font-style: oblique;
  /* font-weight:900; */
  color:rgb(20, 76, 109);
  /* border:  1px solid orange; */
}
#L1 #enviar{
  background-color: var(--azul2);
  color: white;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bolder;
  font-size: 24px;
  padding: 0px 10px 0px 10px;
  border-radius: 3px;
  cursor: pointer;
  min-height: 25px;
  margin-bottom: 2px;
  vertical-align: middle;
  line-height: 20px;
  transition: all 0.5s ease-out;
}
#L1 #enviar:hover{
  transform: translateX(5px);
  /* background-color: rgba(0, 58, 68) */
}
.lista{
  width: 100%;
  min-height: 27px;
  height:98px;
  overflow: auto;
  font-size: 14px;
  border-radius: 3px;
  background-color: var(--gris3);
  border:  1px solid rgb(185, 185, 185);
  cursor:pointer;
}
/* .seleccionado{ */
  /* color:rgb(241, 217, 0); */
/* } */
/* .seleccionado:hover{ */
  /* font-weight:bold; */
/* } */
.autores{
  height: 35px;
  border:  1px solid rgb(185, 185, 185);
  border-radius: 3px;
  font-family: OpenL;
  margin-bottom: 3px;
}
.autores:focus{
  outline: none;
}
.inputAutor{
  display: grid;
}
#nombre{
  margin-bottom: 5px;
  outline:none;
  height: 18px;
}
#apellidos{
  margin-bottom: 10px;
  outline:none;
  height: 18px;
}
#mas{
  background-color:rgba(0, 58, 68, 0.9);
  color:white;
  font-size: 14px;
  font-weight: 600;
}
#L3{
  /* background-color: rgba(0, 58, 68, 0.9); */
  display: flex;
  justify-content: space-around;

  /* padding: 2px; */
}
.button-med{
  width:100px;
  height:30px;
}
.icon-icoMasSolo{
  color: var(--az-ico);
  font-size: 1.3em;
  padding-left: 2px;
  padding-right: 7px;
  /* border:  1px solid rgb(179, 179, 179) */
}
.icon-icoEditSolo{
  color: var(--az-ico);
  font-size: 1.35em;
  padding-left: 0px;
  padding-right: 5px;
  padding-top: 2px;
  /* border:  1px solid rgb(179, 179, 179) */
}
.icon-icoSubirNube{
  color: var(--az-ico);
  font-size: 1.3em;
  padding-left: 0px;
  padding-right: 10px;
  /* border:  1px solid rgb(179, 179, 179) */
}
</style>
